// React Basic and Bootstrap
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Alert } from "reactstrap";

// import images
import img1 from "../../assets/images/SS1.png";
import img2 from "../../assets/images/app/calender.png";
import playstoreImg from "../../assets/images/app/playstore.png";

//Import Components
import Section from "./Section";
import Subscribe from "./subscribe";
import Popup from "../../components/Layout/popup";

const IndexClassicApp = () => {

  useEffect(() => {
    document.body.classList = "";
    window.addEventListener("scroll", scrollNavigation, true);
  });

  const scrollNavigation = () => {
    var doc = document.documentElement;
    const navBar = document.getElementById("topnav");
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (navBar != null) {
      if (top > 80) {
        navBar.classList.add("nav-sticky");
      } else {
        navBar.classList.remove("nav-sticky");
      }
    }
  };

  return (
    <React.Fragment>
      <section
        className="bg-half-170 d-table w-100 overflow-hidden"
        id="home"
      >
        <Container>
          <Row className="align-items-center">
            <Col lg="7" md="7">
              <div className="title-heading mt-4">
                <Alert
                  color="none"
                  className="alert-transparent alert-pills shadow"
                  role="alert"
                >
                  <span className="badge rounded-pill bg-primary me-2">New</span>
                  <span className="content">
                    Paper-Free Solution
                  </span>
                </Alert>
                <h1 className="heading mb-3">
                  Create, Manage & Share Digital Business Visiting Cards Easily
                </h1>
                <p className="para-desc text-muted">
                  DigitCard app that lets you easily manage and organize your business cards in one place, keeping everything accessible, secure, and paper-free.
                </p>
                <div className="mt-4">
                  <a
                    href={process.env.REACT_APP_PLAY_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={playstoreImg} className="m-1" height="50" alt="" />
                  </a>
                </div>
              </div>
            </Col>

            <Col lg="5" md="5" className="mt-4 pt-2 mt-sm-0 pt-sm-0">
              <div className="classic-app-image position-relative">
                <div className="position-relative">
                  <img
                    src={img1}
                    className="img-fluid mover mx-auto d-block"
                    alt=""
                    style={{ width: "75%", height: "auto" }}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* render Section */}
      <Section />

      {/* render subscribe */}
      {/* <Subscribe /> */}

      <Popup />
    </React.Fragment>
  );
}

export default IndexClassicApp;
